<template lang="pug">
section.page-users(v-if="($root.admin || $root.community_manager) && $root.users")
  .back.row.center.between
    button.default.row.center(@click="$router.push('/home')")
      .icon
        font-awesome-icon(icon="chevron-left")
      div {{ t.back }}
    button.orange(@click="$root.admin_modal = {name: 'user', data: {}}") + Add user
  .row.search.flex-1
    input.flex-1(:placeholder="'Filtrer par nom, email...'" v-model="search")
    button.icon
      font-awesome-icon(icon="search")
  .table(v-if="$root.mobile")
    .table-row(v-for="user, uid in filtered_users")
      .name.row
        div {{ t.name }}
        div {{ user.name }}
      .email.row
        div Email
        div {{ user.email }}
      .role.row
        div Role
        div {{ user.role && user.role.titleize() || 'client' }}
      .lang.row(@click="$root.change_user_lang(uid)")
        div {{ t.language }}
        svg-icon(:name="((user.lang || 'fr') === 'fr') ? 'flag-fr' : 'flag-en'")
      .notifications.row
        div {{ t.notifications }}
        .row.center
          .toggle-button(@click="$root.change_notification(uid)")
            input(type="checkbox" :checked="user.notification")
            span.slider.round
      .actions.row
        .row.center.left Actions
        .actions.row.around
          .edit.icon(@click="$root.admin_modal = {name: 'edit_user', data: Object.assign({id: uid},user)}")
            font-awesome-icon(icon="pen")
          .delete.icon(@click="$root.delete_user(uid)")
            font-awesome-icon(icon="trash")





  .table(v-else)
    .header.table-row.row
      .name Nom
      .email Email
      .role Role
      .lang {{ t.language }}
      .notifications.row.center
        .icon
          font-awesome-icon(icon="envelope")
      .actions
    .row.table-row.center(v-for="user, uid in filtered_users")
      .name {{ user.name }}
      .email {{ user.email }}
      .role {{ user.role && user.role.titleize() || 'client' }}
      .lang(@click="$root.change_user_lang(uid)")
        svg-icon(:name="((user.lang || 'fr') === 'fr') ? 'flag-fr' : 'flag-en'")
      .notifications.row.center
        .toggle-button(@click="$root.change_notification(uid)")
          input(type="checkbox" :checked="user.notification")
          span.slider.round
      .actions.row.around
        .edit.icon(@click="$root.admin_modal = {name: 'edit_user', data: Object.assign({id: uid},user)}")
          font-awesome-icon(icon="pen")
        .delete.icon(@click="$root.delete_user(uid)")
          font-awesome-icon(icon="trash")
</template>
<script>
export default {
  data() {
    return {
      email: null,
      password: null,
      search: null,
    }
  },
  mounted() {
    this.$root.admin
  },
  computed: {
    filtered_users() {
      const users = this.$root.users.filter((v,k) => this.$root.admin || v.role === 'client')
      if (!this.search) return users
      const search = new RegExp(this.search, 'i')
      return users.filter(d => search.test(d.name) || search.test(d.email))
    }
  }
}
</script>
<style>
.page.page-users {
  background: white;
}

.laptop .page-users {
  padding: 80px;
}
.laptop .page-users .table {
  padding: 32px;
}
.mobile:not(.laptop) .page-users {
  padding-top: var(--nav-top-height);
}
.mobile:not(.laptop) .page-users .table-row > .row > * {
  flex: 1;
}
.mobile:not(.laptop) .page-users .table-row > .row {
  /* border-bottom: 1px solid var(--lightgrey); */
}
.mobile:not(.laptop) .page-users .table .table-row .actions .icon {
  padding: 2px;
  width: 26px;
  height: 26px;
}
.mobile:not(.laptop) .page-users .back {
  height: var(--nav-top-height);
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 101;
  padding: 0 12px;
}
.mobile:not(.laptop) .page-users .back button.default {
  background: transparent;
  color: white;
  padding: 0;
  height: var(--nav-top-height);
}
.page-users .table .table-row {
  min-height: 36px;
  border-radius: 4px;
}
.page-users .table .header {
  font-weight: bold;
  font-size: 16px;
  background: none!important;
}
.page-users .lang .svg-icon {
  width: 24px;
  height: 24px;
}
.page-users .table .table-row > * {
  flex: 1.5;
  padding: 4px 8px;
}
.page-users .table .table-row .notifications, .page-users .table .table-row .lang {
  flex: 0.4;
}
.page-users .toggle-button input:checked + .slider {
  background-color: var(--primary);
}
.page-users .table .table-row .notifications .icon {
  width: 32px;
  height: 32px;
  color: rgba(0,0,0,0.4);
}
.page-users .table .table-row:nth-child(2n + 1),
.page-users .table .mobile-row:nth-child(2n + 1) {
  background: var(--lightblue);
}
.page-users .table .table-row .actions {
  flex: 1;
}
.page-users .table .table-row .actions .icon {
  width: 36px;
  height: 36px;
  padding: 8px;
  border-radius: 50%;
    color: var(--primary);
}
.page-users .table .table-row .actions .icon:hover {
  background: rgba(0,0,0,0.1);
  cursor: pointer;
}

.page-users .back {
  font-size: 16px;
  color: var(--text);

}
.page-users .back .icon {
  width: 20px;
  height: 20px;
}
.page-users .search {
  height: 54px;
  padding: 0 32px;
  margin-top: 32px;
}
.page-users .search input {
  background: var(--background);
  border-radius: 8px 0 0 8px;
  font-size: 18px;
}
.page-users .search button {
  height: 54px;
}
.page-users .search .icon {
  width: 64px;
  border-radius: 0 8px 8px 0;
  background: #EAEAEA;
}
</style>
